package app.spliddy.web.strings

import kotlin.String

internal object StringsEn : Strings {
  override val app_catch_phrase: String = "Split bills with ease"

  override val app_is_under_construction: String = "🚧This Page is still under construction 🚧"

  override val app_imprint: String = "Imprint"

  override val app_privacy_policy: String = "Privacy Policy"

  override val app_download_app: String = "Download App"

  override val app_name: String = "Spliddy"

  override val footer_built_with_love: String = "Built with️ ❤️ in 🇩🇪"
}
